module.exports = __webpack_public_path__ + "img/choice_port2.0d1ff42e.png";